import { Upload } from "antd";
import classNames from "classnames";
import { BsCloudDownload } from "react-icons/bs";
import { COLORS } from "shared/style/colors";

const { Dragger } = Upload;

const Component = ({
  children,
  handleFileUpload,
  onFileRemove,
  onUpload,
  listType,
  fillWidth,
  className,
  ...rest
}) => (
  <div
    className={classNames("file-dragger--wrapper", {
      "file-dragger--wrapper-full": fillWidth,
    })}
  >
    <div
      className={classNames("dragger__wrapper", {
        "dragger__wrapper-full": fillWidth,
      })}
    >
      <Dragger
        className={classNames(className, {
          "file-dragger--upload-full": fillWidth,
        })}
        onChange={async (info) => {
          const fileList = await handleFileUpload(info);
          onUpload(fileList);
        }}
        onRemove={onFileRemove}
        listType={listType}
        {...rest}
      >
        <div className="dragger__wrapper--icon">
          <BsCloudDownload size={24} color={COLORS.C_PRIMARY} />
        </div>
        <div className="dragger__wrapper--content">
          <p>Glissez votre fichier ici</p>
          <span className="dragger__wrapper--text">
            ou cliquez pour sélectionner depuis le répertoire
          </span>
        </div>
      </Dragger>
    </div>
  </div>
);

export default Component;
